import { render, staticRenderFns } from "./PalletList.vue?vue&type=template&id=0d527532&"
import script from "./PalletList.vue?vue&type=script&lang=js&"
export * from "./PalletList.vue?vue&type=script&lang=js&"
import style0 from "./PalletList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports